import { render, staticRenderFns } from "./UploadImgOrVideo.vue?vue&type=template&id=25ea870e&scoped=true"
import script from "./UploadImgOrVideo.vue?vue&type=script&lang=js"
export * from "./UploadImgOrVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadImgOrVideo.vue?vue&type=style&index=0&id=25ea870e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ea870e",
  null
  
)

export default component.exports